module.exports = __webpack_public_path__ + "ede18477b85a5d781cd2f4001ecc5e67.woff2";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-Light.woff2
// module id = 358
// module chunks = 0